export const WIDTH = 500;
export const TIMELINE_HEIGHT = 20;
export const TIMELINE_V_SPACE = 10;
export const LABEL_OFFSET = 5;
export const MARGIN = { top: 30, right: 0, bottom: 30, left: 0 };
